import ApplicantItem from "../ApplicantItem/ApplicantItem";
import { ABOInfo, PartyInfo, ProfileInfo } from "../../../../services/Profile/profileAPI.types";
import "./ApplicantsList.scss";

type Props = {
  aboInfo: ABOInfo;
  partyInfo: PartyInfo[];
  applicantTrackOnclick: Function;
  profileInfo: Partial<ProfileInfo>;
};

const ApplicantsList = (props: Props) => {
  const { aboInfo, partyInfo, applicantTrackOnclick, profileInfo } = props;

  return (
    <div className="leaf-applicants-list">
      {partyInfo.map((info, index) => {
        return (
          <div className="leaf-applicants-list__border" key={index}>
            <ApplicantItem
              key={index}
              isExpandable={true}
              aboInfo={aboInfo}
              partyInfo={info}
              applicantTrackOnclick={applicantTrackOnclick}
              profileInfo={profileInfo}
            />
          </div>
        );
      })}
    </div>
  );
};
export default ApplicantsList;
